/**
 * StepIndicator - Step progress indicator for wizard
 * Converted from TypeScript for PromptusAI PWA
 */

import React from 'react';
import { Icons } from './MediaComponents';

const defaultStepLabels = ['Model & Prompt', 'Gallery Content', 'Details', 'Preview'];

export function StepIndicator({
  currentStep,
  totalSteps,
  stepLabels = defaultStepLabels,
  classNames = {},
}) {
  return (
    <div className={`flex items-center justify-between max-w-xl mx-auto ${classNames.container || ''}`}>
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep >= stepNumber;
        const isCompleted = currentStep > stepNumber;
        const label = stepLabels[index] || `Step ${stepNumber}`;

        return (
          <React.Fragment key={stepNumber}>
            <div className="flex flex-col items-center">
              <div
                className={`
                  w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-colors
                  ${isActive
                    ? `bg-yellow text-dark-blue ${classNames.stepActive || ''}`
                    : `bg-dark-blue/50 text-white/50 ${classNames.step || ''}`
                  }
                  ${isCompleted ? classNames.stepCompleted || '' : ''}
                `}
              >
                {isCompleted ? <Icons.Check /> : stepNumber}
              </div>
              <span className={`text-xs text-white/50 mt-1 hidden sm:block ${classNames.label || ''}`}>
                {label}
              </span>
            </div>
            {index < totalSteps - 1 && (
              <div
                className={`
                  flex-1 h-0.5 mx-2 transition-colors
                  ${currentStep > stepNumber
                    ? `bg-yellow ${classNames.connectorActive || ''}`
                    : `bg-dark-blue/50 ${classNames.connector || ''}`
                  }
                `}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default StepIndicator;
